import React from 'react';

function renderTemplateList(data, props) {
	let templates = [];
	if (data && data.length) {
		templates = data.map((template) => (
			<button
				type="button"
				key={template.id}
				className="btn btn-light w-100 my-2 y-1"
				// onClick={props.onChangePreDefinedAccount}
			>
				{template.template_name}
			</button>
		));
	}
	return templates;
}

export default function PreDefinedAccountTypeCard(props) {
	// console.log('PreDefinedAccountTypeCard', props);
	return (
		<div className="PreDefinedAccountTypeCard p-2 mx-auto d-inline-block h-100">
			<div className="card border h-100">
				<div className="card-body w-100 mx-auto text-center px-4">
					<h1 className="card-title mx-auto mx-4">
						{I18n.t('admin.predefined_account_title')}
					</h1>
					<hr />
					<span className="mb-3 d-block">
						{I18n.t('admin.predefined_account_instructions')}
					</span>
					<div>{renderTemplateList(props.data)}</div>
					<hr />
					<button
						type="button"
						className="btn btn-primary w-100 mt-2"
						onClick={() => {
							props.onHidePopup();
							props.onShowPopup();
						}}
					>
						{I18n.t('admin.use_selected_configuration')}
					</button>
				</div>
			</div>
		</div>
	);
}
